import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from '../components/Sidebar';
import BottomNav from '../components/BottomNav';

export default function AppLayout({ children }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md')); // Switch to mobile nav on tablets too

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', position: 'relative' }}>
      {/* Navigation */}
      {isMobile ? <BottomNav /> : <Sidebar />}

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          // Adjust margins based on layout
          ml: isMobile ? 0 : '320px', // Sidebar width (280) + gap (40)
          mb: isMobile ? '100px' : 0, // BottomNav height + gap
          width: '100%',
          position: 'relative'
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
